import request from '@/utils/request';

// 登录
export function Login(data) {
    return request({
        url: '/wisc/login',
        method: 'POST',
        data
    });
}

export function QueryClickCaptcha() {
    return request({
        url: '/wisc/login/clickCaptcha',
        method: 'GET'
    });
}

export function VerifyClickCaptcha(data) {
    return request({
        url: '/wisc/login/verifyClickCaptcha',
        method: 'POST',
        data
    });
}
